import * as turf from '@turf/turf';

const axlesLengthFactor = 0.1;

export function handleAxlesVisibility(map, showAxles) {
    let visibility = showAxles ? 'visible' : 'none'
    map.setLayoutProperty('axlesLineLayer', 'visibility', visibility)
    map.setLayoutProperty('axleNamesLayer', 'visibility', visibility)
}

export function getAxleFeatures(axlesData, levelsData) {
    let features = []
    let axleNamesFeatures = []
    for (const axleData of Object.values(axlesData)) {
        let line = getAxleLineFromPoint(
            axleData.attributes.longitude,
            axleData.attributes.latitude,
            axleData.attributes.angle
        )
        line = adjustLineToFitBoundingBox(line, levelsData)
        if (line.length < 2) {
            console.log(`Eje ${axleData.attributes.name}, no pudo ser dibujado`)
            continue 
        }
        features.push({
            id: axleData.id,
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: line
            },
        })
        for (const point of line) {
            axleNamesFeatures.push({
                id: axleData.id,
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: point
                },
                properties: {
                    name: axleData.attributes.name
                },
            })
        }
    }
    return [features, axleNamesFeatures]
}

function getLevelBoundingBox(levelData) {
    return turf.lineString([
        [levelData.attributes.top_left_longitude, levelData.attributes.top_left_latitude],
        [levelData.attributes.top_right_longitude, levelData.attributes.top_right_latitude],
        [levelData.attributes.down_right_longitude, levelData.attributes.down_right_latitude],
        [levelData.attributes.down_left_longitude, levelData.attributes.down_left_latitude],
        [levelData.attributes.top_left_longitude, levelData.attributes.top_left_latitude]
    ])
}

function getAxleLineFromPoint(longitude, latitude, angle) {
    let angleInRad = parseFloat(angle)*Math.PI/180
    let pointX = parseFloat(longitude)
    let pointY = parseFloat(latitude)
    let x1 = pointX + axlesLengthFactor*Math.cos(angleInRad)
    let y1 = pointY + axlesLengthFactor*Math.sin(angleInRad)
    let x2 = pointX - axlesLengthFactor*Math.cos(angleInRad)
    let y2 = pointY - axlesLengthFactor*Math.sin(angleInRad)
    return [[x1, y1], [x2, y2]]
}

function adjustLineToFitBoundingBox(rawLine, levelsData) {
    for (const levelData of Object.values(levelsData)) {
        let bbox = getLevelBoundingBox(levelData);
        let line = turf.lineString(rawLine)
        let intersectionPoints = turf.lineIntersect(
            line, 
            bbox,
        )
        let fittedLine = []
        intersectionPoints.features.forEach(point => {
            fittedLine.push(point.geometry.coordinates)
        })
        if (fittedLine.length === 2) {
            return fittedLine
        }
    }
    return [];
}